import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {Card, Container, Typography} from '@mui/material';

export const Home: FC<unknown> = () => {
    const {t} = useTranslation();

    return (
        <Container
            sx={{
                paddingTop: '1rem',
                width: '100%',
                height: '100%'
            }}
        >
            <Card
                sx={{
                    width: '100%',
                    height: '100%'
                }}
            >
                <Typography
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        height: '70vh',
                        justifyContent: 'center',
                        textAlign: 'center'
                    }}
                    variant='h2'
                >
                    {t('home.welcome')}
                    <br/>
                    {t('home.getStarted')}
                </Typography>
            </Card>
        </Container>
    );
};
